import { render, staticRenderFns } from "./DetailFulfillment.vue?vue&type=template&id=e80e91f8&"
import script from "./DetailFulfillment.vue?vue&type=script&lang=js&"
export * from "./DetailFulfillment.vue?vue&type=script&lang=js&"
import style0 from "./DetailFulfillment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports